(function (app, ng) {

    app.component("transactionGroupProducts",
        {
            controller: transactionGroupProductsController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Products/configure-transaction-group-products-template.html",
            bindings: {
                onSave: "&",
                products: "=",
                transactionGroupProducts: "=",
                transactionGroup: "<",
                publishedProducts: "<"
            }
        });

    transactionGroupProductsController.$inject = ["_", "$q", "transactionGroupProductApi", "transactionGroupApi"];
    function transactionGroupProductsController(_, $q, transactionGroupProductApi, transactionGroupApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                productCarrierSort: [],
                transactionGroupProductCarrierSort: [],
                activateProduct: activateProduct,
                deactivateProduct: deactivateProduct,
                excludeTrxProductFromReviewQueue: excludeTrxProductFromReviewQueue,
            });

        this.$onInit = function () {

            transactionGroupApi.getQueueWorkflow($ctrl.transactionGroup.QueueWorkflowId).then(function (response) {
                $ctrl.queueWorkflow = response;
            });

            ng.forEach($ctrl.transactionGroupProducts,
                function (product) {
                    if (!_.some($ctrl.transactionGroupProductCarrierSort,
                        function (row) {
                            return row.Id === product.Product.Carrier.Id;
                        }))
                        $ctrl.transactionGroupProductCarrierSort
                            .push({ Id: product.Product.Carrier.Id, Name: product.Product.Carrier.Business.Name });
                });


            $ctrl.products = _.filter($ctrl.products,
                function (product) {
                    return !_.some($ctrl.transactionGroupProducts,
                        function (row) {
                            return row.ProductId === product.Id;
                        });
                });

            ng.forEach($ctrl.products,
                function (product) {
                    if (!_.some($ctrl.productCarrierSort,
                        function (row) {
                            return row.Id === product.Carrier.Id;
                        }))
                        $ctrl.productCarrierSort.push({ Id: product.Carrier.Id, Name: product.Carrier.Business.Name });
                });
            var unpublishedAdditions = [];
            ng.forEach($ctrl.transactionGroupProducts, function (product) {
                if (!_.find($ctrl.publishedProducts, function (p) { return p.ProductId === product.ProductId; })) {
                    unpublishedAdditions.push(product);
                }
            });

            var unpublishedDeletes = [];
            ng.forEach($ctrl.publishedProducts, function (product) {
                if (!_.find($ctrl.transactionGroupProducts, function (p) { return p.ProductId === product.ProductId })) {
                    unpublishedDeletes.push(product);
                };
            });

            ng.forEach(unpublishedAdditions, function (a) {
                _.find($ctrl.transactionGroupProducts, function (p) {
                    return a.ProductId === p.ProductId;
                }).Unpublished = true;
            });

            ng.forEach(unpublishedDeletes, function (d) {
                _.find($ctrl.products, function (p) {
                    return d.ProductId === p.Id;
                }).Unpublished = true;
            });
        };

        function activateProduct(product) {
            console.log(product)
            $ctrl.products = _.filter($ctrl.products,
                function (row) {
                    return row.Id !== product.Id;
                });

            var transactionGroupProduct = {
                ProductId: product.Id,
                TransactionGroupId: $ctrl.transactionGroup.Id,
                ExcludeFromReviewQueue: false,
                Product: product,
                IsActive: product.IsActive
            };

            if (!_.some($ctrl.transactionGroupProducts,
                function (row) {
                    return row.Product.Carrier.Id === product.Carrier.Id;
                }))
                $ctrl.transactionGroupProductCarrierSort
                    .push({ Id: product.Carrier.Id, Name: product.Carrier.Business.Name });

            if (!_.some($ctrl.products,
                function (row) {
                    return row.Carrier.Id === product.Carrier.Id;
                }))
                $ctrl.productCarrierSort = _.filter($ctrl.productCarrierSort,
                    function (row) {
                        return row.Id !== product.Carrier.Id;
                    });

            transactionGroupProduct.Unpublished = !product.Unpublished;

            updateUnpublishedChanges(transactionGroupProduct);

            $ctrl.transactionGroupProducts.push(transactionGroupProduct);
            transactionGroupProductApi.createTransactionGroupProduct(transactionGroupProduct)
                .then(function (response) {
                    transactionGroupProduct.Id = response.Id;
                    transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
                });
            return true;
        }

        function deactivateProduct(product) {
            $ctrl.transactionGroupProducts = _.filter($ctrl.transactionGroupProducts,
                function (row) {
                    return row.Id !== product.Id;
                });

            excludeTrxProductFromReviewQueue(product);

            if (!_.some($ctrl.products,
                function (row) {
                    return row.Carrier.Id === product.Product.Carrier.Id;
                }))
                $ctrl.productCarrierSort.push({
                    Id: product.Product.Carrier.Id,
                    Name: product.Product.Carrier.Business.Name
                });

            if (!_.some($ctrl.transactionGroupProducts,
                function (row) {
                    return row.Product.Carrier.Id === product.Product.Carrier.Id;
                }))
                $ctrl.transactionGroupProductCarrierSort = _.filter($ctrl.transactionGroupProductCarrierSort,
                    function (row) {
                        return row.Id !== product.Product.Carrier.Id;
                    });

            product.Product.Unpublished = !product.Unpublished;
            updateUnpublishedChanges(product.Product);
            $ctrl.products.push(product.Product);
            transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            product.IsActive = false;
            transactionGroupProductApi.updateIsActive(product);
            return true;
        }

        function excludeTrxProductFromReviewQueue(product) {
            product.Product.Unpublished = true;
            updateUnpublishedChanges(product.Product);
            transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            transactionGroupProductApi.updateExludeFromReviewQueue(product);
        }

        function updateUnpublishedChanges(item) {
            if (item.Unpublished === true)
                $ctrl.transactionGroup.UnpublishedChanges++;
            else
                $ctrl.transactionGroup.UnpublishedChanges--;
        }
    };
})(window.app, window.angular); //jshint ignore:line